const bundle = {
  close: () => '關閉',
  error: () => '錯誤',
  warn: () => '警告',
  info: () => '資訊',
  confirmation: () => '確認',
  progressIndeterminate: () => '進行中',
  indexer_separatorLabel: (p: { FROM_SECTION: string; TO_SECTION: string }) =>
    '在 ' + p['FROM_SECTION'] + ' 到 ' + p['TO_SECTION'] + ' 之間.',
  indexer_disabledLabel: (p: { SECTION: string }) => p['SECTION'] + '. 找不到符合的區段.',
  indexer_othersLabel: () => '#',
  indexer_keyboardInstructionText: () => '按 Enter 鍵以選取值.',
  indexer_touchInstructionText: () => '點兩下並按住以進入手勢模式, 您可以上下拖曳來調整值.',
  inputPassword_show: () => '顯示密碼',
  inputPassword_hide: () => '隱藏密碼',
  inputPassword_hidden: () => '已隱藏密碼',
  formControl_clear: () => '清除',
  formControl_loading: () => '載入中',
  formControl_maxLengthExceeded: (p: { MAX_LENGTH: string }) =>
    '超過長度上限 ' + p['MAX_LENGTH'] + '.',
  formControl_maxLengthRemaining: (p: { CHARACTER_COUNT: string }) =>
    '還有 ' + p['CHARACTER_COUNT'] + ' 個字元.',
  select_noMatchesFound: () => '找不到相符項目.',
  select_oneMatchFound: () => '找到一個相符項目',
  select_sizeMatchesFound: (p: { TOTAL_SIZE: string }) => '找到 ' + p['TOTAL_SIZE'] + ' 個相符項目',
  select_sizeOrMoreMatchesFound: (p: { TOTAL_SIZE: string }) =>
    '找到 ' + p['TOTAL_SIZE'] + ' 個以上的相符項目',
  selectMultiple_showSelectedValues: () => '僅顯示選取的值.',
  selectMultiple_valuesSelected: (p: { VALUE_COUNT: string }) =>
    '已選取 ' + p['VALUE_COUNT'] + ' 個值.',
  selectMultiple_countPlus: (p: { COUNT: string }) => p['COUNT'] + '+',
  selector_selected: () => '已勾選核取方塊',
  selector_unselected: () => '未勾選核取方塊',
  userAssistance_learnMore: () => '進一步瞭解',
  userAssistance_required: () => '必要',
  filePicker_singleFileUploadError: () => '一次上傳一個檔案',
  filePicker_singleTypeUploadError: (p: { fileType: string }) =>
    '您無法上傳 ' + p['fileType'] + ' 類型的檔案',
  filePicker_multipleFileTypeUploadError: (p: { fileTypes: string }) =>
    '您無法上傳以下類型的檔案: ' + p['fileTypes'],
  filePicker_unknownFileTypeUploadError: () => '不明',
  filePicker_dropzonePrimaryText: () => '拖放',
  filePicker_dropzoneSecondaryText: () => '選取一個檔案或將一個檔案放到此處',
  filePicker_dropzoneSecondaryTextMultiple: () => '選取或將檔案放到此處',
  filePicker_addFiles: () => '新增檔案',
  plural_separator: () => ', ',
  inputNumber_increase: () => '增加',
  inputNumber_decrease: () => '減少',
  inputNumber_converterParseError: () => 'Enter a number.',
  noData_message: () => '沒有可顯示的項目',
  message_navigationFromMessagesRegion: () => '進入訊息區域. 按 F6 即可回到先前聚焦的元素.',
  message_navigationToMessagesRegion: () => '訊息區域有新的訊息. 按 F6 即可瀏覽至最新的訊息區域.',
  messageToast_allMessagesClosed: () => '所有通知訊息都已關閉.'
};
export default bundle;
